/**
 * Replaces all question mark characters in the input string with the phrase ' Question Mark '.
 *
 * @param {string} input - The string to normalize by replacing question marks.
 * @returns {string} The normalized string with question marks replaced.
 */
const normalizeQuestionMark = (input) => {
  return input.replace(/\?/g, ' Question Mark ')
}

export default normalizeQuestionMark
